'use client';

import { c as _c } from "react/compiler-runtime";
import type { RegistroDeAnexos } from '../../types/baixarProcesso.types';
import { eventoDoAnexo, paginasDoAnexo, resultadoDoAnexo } from '../../utils/anexosDoRegistro';
interface RegistroDeAnexosDoPacoteProps {
  registro: RegistroDeAnexos;
}

/**
 * O registro de todos os anexos do pacote, para a Secretaria conferir a completude dos autos
 * (AUT-ANX-002): cada anexo com o evento de origem, o que aconteceu com ele e onde está no PDF.
 * Fechado por padrão: é consulta, e o download continua sendo a ação da tela.
 */
export function RegistroDeAnexosDoPacote(t0) {
  const $ = _c(11);
  const {
    registro
  } = t0;
  if (registro.anexos.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== registro.anexos.length) {
    t1 = <summary className="text-default-font cursor-pointer px-[14px] py-[11px] text-[13px] font-medium">Registro de anexos ({registro.anexos.length})</summary>;
    $[0] = registro.anexos.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <caption className="sr-only">Destino de cada anexo do processo no PDF dos autos</caption>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <thead><tr className="text-[10.5px] tracking-[0.05em] text-neutral-500 uppercase"><th className="px-[14px] py-2 font-semibold" scope="col">Anexo</th><th className="px-2 py-2 font-semibold" scope="col">Origem</th><th className="px-2 py-2 font-semibold" scope="col">Resultado</th><th className="px-[14px] py-2 text-right font-semibold" scope="col">No PDF</th></tr></thead>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== registro.anexos) {
    t4 = registro.anexos.map(_temp);
    $[4] = registro.anexos;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="overflow-x-auto border-t border-solid border-neutral-100"><table className="w-full border-collapse text-left text-[12px]">{t2}{t3}<tbody>{t4}</tbody></table></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t5) {
    t6 = <details className="group rounded-[8px] border border-solid border-neutral-200">{t1}{t5}</details>;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(anexo) {
  return <tr className="border-t border-solid border-neutral-100" key={anexo.anexoId}><td className="text-default-font max-w-[180px] truncate px-[14px] py-2 font-medium">{anexo.nome}</td><td className="px-2 py-2 whitespace-nowrap text-neutral-600">{eventoDoAnexo(anexo.eventoNumero)}</td><td className={`px-2 py-2 ${anexo.tratamento === "INCORPORAR" ? "text-neutral-600" : "text-warning-700"}`}>{resultadoDoAnexo(anexo)}</td><td className="px-[14px] py-2 text-right whitespace-nowrap text-neutral-600 tabular-nums">{paginasDoAnexo(anexo)}</td></tr>;
}